import { useMemo } from "react";

import useLocalizedOptionsConfiguration from "./useLocalizedOptionsConfiguration";

export default function useNormalizedEvaluationOptions() {
  const evaluationOptionsConfiguration =
    useLocalizedOptionsConfiguration().evaluationQuestionOptionsConfiguration;

  const normalizedOptions = useMemo(() => {
    const normalizedConfiguration = evaluationOptionsConfiguration.map(
      ({ value, ...rest }) => ({
        ...rest,
        value:
          evaluationOptionsConfiguration.length > 1
            ? (1 / (evaluationOptionsConfiguration.length - 1)) *
              parseInt(value)
            : 1,
      })
    );

    return normalizedConfiguration;
  }, [evaluationOptionsConfiguration]);

  return normalizedOptions;
}
